import { AngularFireDatabase } from 'angularfire2/database';
import { CoinsProvider } from './../coins/coins';
import { Injectable, ViewChild } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/mergeMap';

import { Platform, LoadingController } from 'ionic-angular';
import { GooglePlus } from '@ionic-native/google-plus';

import { getQueryParam } from '../../models/Util';

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthProvider {
  authState: firebase.User = null;

  // public authToken: string = null; //This one is used for outbound

  //Public afAuth because observable authenticated boolean
  constructor(
    public afAuth: AngularFireAuth,
    private db: AngularFireDatabase,
    public CP: CoinsProvider,
    private platform: Platform,
    private gplus: GooglePlus,
    private loadingCtrl: LoadingController
  ) {
    //Sign in with query param if possible
    let token = getQueryParam('authToken', document.URL);
    if(token){
      const loader = this.loadingCtrl.create();
      this.afAuth.auth.signInWithCustomToken(token).then(() => {
        loader.dismiss();
      })
      .catch(error => {
        loader.dismiss();
      })
    }

    afAuth.authState.subscribe(auth => {
      this.authState = auth;
    });
  }

  public getUserId(): Observable<string>{
    return this.afAuth.authState
      .map((auth: firebase.User) => {
        if (auth) return auth.uid;
        else return null;
      })
  }

  // Returns true if user is logged in
  get authenticated(): boolean {
    return this.authState != null;
  }

  get isAuthenticated(): Observable<boolean> {
    return this.afAuth.authState.map(user => {
      if(user) return true;
      else return false;
    })
  }

  // Returns current user UID
  get currentUserId(): string {
    return this.authenticated ? this.authState.uid : "";
  }
  //Stuff that should get refactored into a TS class

  //Authentication
  googleLogin(): Promise<void> {
    if (this.platform.is('cordova')) {
      return this.gplus.login({
        'webClientId': '469025252700-kpq3ivfpgm63k7spo5u2ah64vutfhcbs.apps.googleusercontent.com',
        'offline': true,
        'scopes': 'profile email'
        })
        .then(gplusUser => {
          const gplusCredential = firebase.auth.GoogleAuthProvider.credential(gplusUser.idToken)
          return firebase.auth().signInWithCredential(gplusCredential)
            .then(success => {
            });
        }).catch((error) => { console.log(error) });
    } else {
      const provider = new firebase.auth.GoogleAuthProvider();
      return this.socialSignIn(provider);
    }
  }

  private socialSignIn(provider) {
    return this.afAuth.auth
      .signInWithPopup(provider)
      .then((credential: firebase.auth.UserCredential) => {
        this.authState = credential.user;
        this.initializeUser(null);
      })
  }

  emailSignUp(email: string, password: string, displayName: string) {
    return this.afAuth.auth
      .createUserWithEmailAndPassword(email, password)
      .then((user: firebase.User) => {
        this.authState = user;
        this.initializeUser(displayName); //secondary measure
      })
  }

  emailLogin(email: string, password: string) {
    return this.afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then((user: firebase.User) => {
        this.authState = user;
      })
    // .catch(error => console.log(error));
  }

  signOut() {
    return this.afAuth.auth.signOut().then(() => {

    });
  }

  sendPasswordResetEmail(email){
    return firebase.auth().sendPasswordResetEmail(email);
  }

  private initializeUser(displayName: string) {
    if (this.currentUserId) {
      if(displayName){
        this.db.object(`users/${this.currentUserId}`).update({displayName: displayName})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts